export default "__VITE_ASSET__jRqy9oph__"